import { React, useEffect } from "react";
import Loader from "../Loader/Loader";
import FileCard from "../FIleCard/FileCard";
import styles from "./Home.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { fetchHomeFiles } from "../service/apiService";
import { fetchFilesRequest } from "../../Redux/Files/FileActions";
import { uploadFile } from "../service/actionServices";

function Home({  deleteHandler }) {
  const dispatch = useDispatch();

  const filesData = useSelector((state) => state.allFiles); 
  const userData = useSelector(state => state.user)
  let userId = userData && userData.userId && userData.userId
  console.log(userId)
  useEffect(() => {
    dispatch(fetchFilesRequest());
    dispatch(fetchHomeFiles(userId));

  }, []);

  return filesData && filesData.loading ? (
    <div>
      <Loader />
    </div>
  ) : (
    <>
      {filesData && filesData.files && filesData.files.length !== 0 ? (

        <div className={`container ${styles.homeContainer}`}>
          {filesData &&
            filesData.files &&
            filesData.files.map((file) => {
              return (
                <FileCard
                  key={file._id}
                  file={file}
                  page={"home"}
                  filesList = {filesData && filesData.files && filesData.files}
                  deleteHandler={deleteHandler}
                />
              );
            })}
        </div>
      ) : (
        <div className={styles.noFileMessage}>
          <h1>You dont have any files...may be add one?</h1>
          {/* <button className={styles.addFileBtn}> Add File</button> */}
        </div>
      )}
    </>
  );
}

export default Home;
